"use client"

import SubHeadingElement from "@/app/(site)/_components/GCMolecules/SubHeadingElement"
import { type SubHeadingGroupType } from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

export default function SubHeadingGroup({
    subHeadingElement,
    textColor,
    className
}: SubHeadingGroupType) {
    if (!subHeadingElement?.text) return null

    return (
        <SubHeadingElement
            text={subHeadingElement.text}
            className={clsx(textColor, className)}
        />
    )
}
